/**
 * Query string for GET requests: null, undefined, '' and empty arrays are
 * dropped; an array goes out as ONE comma-joined value (`deviceId=1,2,3`),
 * each item encoded on its own and the joining comma left literal. Repeated
 * keys (`deviceId=1&deviceId=2`) overflow nginx's 8 KB request line at ~540
 * vehicles; the server's parseDeviceIds / parseDeviceIdFilter split commas.
 */
// Same form encoding URLSearchParams uses (space → '+'), so scalar values go out byte-for-byte as before.
const enc = (x) => new URLSearchParams({ x: String(x) }).toString().slice(2);

export function queryString(params = {}) {
  const parts = [];
  for (const [k, v] of Object.entries(params || {})) {
    if (v == null || v === '') continue;
    const value = Array.isArray(v)
      ? v.filter((x) => x != null && x !== '').map(enc).join(',')
      : enc(v);
    if (value === '') continue;
    parts.push(`${enc(k)}=${value}`);
  }
  return parts.join('&');
}
